import React from "react";
import { useLang } from "../context/LangContext";
import "../styles/components/Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  const langState = useLang() || {};
  const dict = langState.dict || {};
  const footerDict = dict.footer || {};

  const text = {
    brand: footerDict.brand || "",
    tagline: footerDict.tagline || "",
    rightsReserved: footerDict.rightsReserved || "",
    ariaLabel: footerDict.ariaLabel || "Footer",
  };

  return (
    <footer className="footer" aria-label={text.ariaLabel}>
      <div className="footer__glow footer__glow--a" />
      <div className="footer__glow footer__glow--b" />
      <div className="footer__depth" />

      <div className="footer__inner">
        <div className="footer__left">
          {text.brand ? <h3 className="footer__brand">{text.brand}</h3> : null}
          {text.tagline ? (
            <div className="footer__tagline">{text.tagline}</div>
          ) : null}
        </div>

        <div className="footer__right">
          <span className="footer__year">@ {year}</span>
          {text.rightsReserved ? (
            <span className="footer__rights">{text.rightsReserved}</span>
          ) : null}
        </div>
      </div>
    </footer>
  );
}